/* eslint-disable @typescript-eslint/no-explicit-any */
import { Ratio2x3Icon } from "../assets/ratio-2x3-icon";
import { Ratio3x2Icon } from "../assets/ratio-3x2-icon";
import { Ratio16x9Icon } from "../assets/ratio-16x9-icon";
import { Ratio21x9Icon } from "../assets/ratio-21x9-icon";
import { Ratio3x4Icon } from "../assets/ratio-3x4-icon";
import { Ratio4x3Icon } from "../assets/ratio-4x3-icon";
import { Ratio9x16Icon } from "../assets/ratio-9x16-icon";
import { Ratio1x1Icon } from "../assets/ratio-1x1-icon";
import { Ratio4x5Icon } from "../assets/ratio-4x5-icon";
import { Ratio5x4Icon } from "../assets/ratio-5x4-icon";
import { KLING_V26_PRO, NANO_BANANA, NANO_BANANA_PRO, SEEDREAM_V45, SORA2, SORA2_PRO } from "./ai-creation-model";
import { AiCreationParams } from "@/manager/manager/agent-user-messages-manager";

/** 通用输出数量 */
export const OUTPUT_COUNT_OPTIONS = [
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
]

/** 通用时长 */
export const DURATION_OPTIONS = [
  {
    label: '4s',
    value: '4',
  },
  {
    label: '8s',
    value: '8',
  },
  {
    label: '12s',
    value: '12',
  },
]

/** Sora 视频比例 */
export const VIDEO_SORA_RATIO_OPTIONS = [
  {
    label: '9:16',
    value: '9:16',
    icon: Ratio9x16Icon,
  },
  {
    label: '16:9',
    value: '16:9',
    icon: Ratio16x9Icon,
  },
]

/** Sora 视频分辨率 */
export const VIDEO_SORA_IMAGE_SIZE_OPTIONS = [
  {
    label: '720p',
    value: '720p',
  },
  {
    label: '1080p',
    value: '1080p',
  },
]

/** Nano banana 图片比例 */
export const NANO_BANANA_RATIO_OPTIONS = [
  {
    label: '9:16',
    value: '9:16',
    icon: Ratio9x16Icon,
  },
  {
    label: '3:4',
    value: '3:4',
    icon: Ratio3x4Icon,
  },
  {
    label: '1:1',
    value: '1:1',
    icon: Ratio1x1Icon,
  },
  {
    label: '4:3',
    value: '4:3',
    icon: Ratio4x3Icon,
  },
  {
    label: '16:9',
    value: '16:9',
    icon: Ratio16x9Icon,
  },
  {
    label: '4:5',
    value: '4:5',
    icon: Ratio4x5Icon,
  },
  {
    label: '5:4',
    value: '5:4',
    icon: Ratio5x4Icon,
  },
  {
    label: '2:3',
    value: '2:3',
    icon: Ratio2x3Icon,
  },
  {
    label: '3:2',
    value: '3:2',
    icon: Ratio3x2Icon,
  },
  {
    label: '21:9',
    value: '21:9',
    icon: Ratio21x9Icon,
  },
]

/** Nano banana 图片分辨率 */
export const NANO_BANANA_IMAGE_SIZE_OPTIONS = [
  {
    label: '1K',
    value: '1K',
  },
  {
    label: '2K',
    value: '2K',
  },
  {
    label: '4K',
    value: '4K',
  },
]

/** 可灵2.6pro 视频分辨率 */
export const VIDEO_KLING_RATIO_OPTIONS = [
  {
    label: '9:16',
    value: '9:16',
    icon: Ratio9x16Icon,
  },
  {
    label: '16:9',
    value: '16:9',
    icon: Ratio16x9Icon,
  },

  {
    label: '1:1',
    value: '1:1',
    icon: Ratio1x1Icon,
  },
]

/** 可灵2.6pro 视频时长 */
export const VIDEO_KLING_DURATION_OPTIONS = [
  {
    label: '5s',
    value: '5',
  },
  {
    label: '10s',
    value: '10',
  },
]

/** seedream-v4.5 图片比例 */
export const SEEDREAM_V45_RATIO_OPTIONS = [
  {
    label: '9:16',
    value: '9:16',
    icon: Ratio9x16Icon,
  },
  {
    label: '3:4',
    value: '3:4',
    icon: Ratio3x4Icon,
  },
  {
    label: '1:1',
    value: '1:1',
    icon: Ratio1x1Icon,
  },
  {
    label: '4:3',
    value: '4:3',
    icon: Ratio4x3Icon,
  },
  {
    label: '16:9',
    value: '16:9',
    icon: Ratio16x9Icon,
  },
  {
    label: '4:5',
    value: '4:5',
    icon: Ratio4x5Icon,
  },
  {
    label: '5:4',
    value: '5:4',
    icon: Ratio5x4Icon,
  },
  {
    label: '2:3',
    value: '2:3',
    icon: Ratio2x3Icon,
  },
  {
    label: '3:2',
    value: '3:2',
    icon: Ratio3x2Icon,
  },
  {
    label: '21:9',
    value: '21:9',
    icon: Ratio21x9Icon,
  },
]

/** seedream-v4.5 图片分辨率 */
export const SEEDREAM_V45_IMAGE_SIZE_OPTIONS = [
  {
    label: '2K',
    value: '2K',
  },
  {
    label: '4K',
    value: '4K',
  },
]

// 模型参数配置表
export const MODEL_PARAMS_CONFIGS: Record<string, any> = {
  // ==================== 视频模型 ===================
  // [SORA2]: {
  //   fields: ['aspectRatio', 'duration'],
  //   options: {
  //     aspectRatio: VIDEO_SORA_RATIO_OPTIONS,
  //     duration: DURATION_OPTIONS
  //   },
  // },
  // [SORA2_PRO]: {
  //   fields: ['aspectRatio', 'imageSize', 'duration'],
  //   options: {
  //     aspectRatio: VIDEO_SORA_RATIO_OPTIONS,
  //     imageSize: VIDEO_SORA_IMAGE_SIZE_OPTIONS,
  //     duration: DURATION_OPTIONS
  //   },
  // },
  [KLING_V26_PRO]: {
    fields: ['aspectRatio', 'duration'],
    options: {
      aspectRatio: VIDEO_KLING_RATIO_OPTIONS,
      duration: VIDEO_KLING_DURATION_OPTIONS
    },
    disableRatioByRef: true, // 图片模型不受参考图影响
  },
  // ==================== 图片模型 ===================
  [NANO_BANANA]: {
    fields: ['aspectRatio', 'count'],
    options: {
      aspectRatio: NANO_BANANA_RATIO_OPTIONS,
      imageSize: NANO_BANANA_IMAGE_SIZE_OPTIONS,
      count: OUTPUT_COUNT_OPTIONS
    },
    // disableRatioByRef: false, // 图片模型不受参考图影响
    maxInputFileSize: 7 * 1024 * 1024, // 7MB
  },
  [NANO_BANANA_PRO]: {
    fields: ['aspectRatio', 'imageSize', 'count'],
    options: {
      aspectRatio: NANO_BANANA_RATIO_OPTIONS,
      imageSize: NANO_BANANA_IMAGE_SIZE_OPTIONS,
      count: OUTPUT_COUNT_OPTIONS
    },
    // disableRatioByRef: false,
    maxInputFileSize: 7 * 1024 * 1024, // 7MB
  },
  [SEEDREAM_V45]: {
    fields: ['aspectRatio', 'imageSize', 'count'],
    options: {
      aspectRatio: SEEDREAM_V45_RATIO_OPTIONS,
      imageSize: SEEDREAM_V45_IMAGE_SIZE_OPTIONS,
      count: OUTPUT_COUNT_OPTIONS,
    },
    // disableRatioByRef: false,
    maxImageWidth: 4090,
    maxImageHeight: 4090,
    maxInputFileSize: 10 * 1024 * 1024, // 10MB
  }
};

// 默认配置常量
export const CREATION_DEFAULT_CONFIG = {
  video: {
    defaultModel: KLING_V26_PRO,
    models: {
      // [SORA2]: {
      //   aspectRatio: '9:16', duration: '8', count: ''
      // },
      // [SORA2_PRO]: {
      //   aspectRatio: '9:16', duration: '8', imageSize: '720p', count: ''
      // },
      [KLING_V26_PRO]: { aspectRatio: '9:16', duration: '5', count: '' },
    }
  },
  image: {
    defaultModel: NANO_BANANA,
    models: {
      [NANO_BANANA]: { aspectRatio: '9:16', imageSize: '2K', count: '1', duration: '' },
      [NANO_BANANA_PRO]: { aspectRatio: '9:16', imageSize: '2K', count: '1', duration: '' },
      [SEEDREAM_V45]: { aspectRatio: '9:16', imageSize: '2K', count: '1', duration: '' },
    }
  }
};
